export const navigation = [
  { label: "Home", href: "/#top" },
  { label: "Products", href: "/products" },
  { label: "Sourcing", href: "/services" },
  { label: "For Manufacturers", href: "/for-manufacturers" },
  { label: "How It Works", href: "/how-it-works" },
  { label: "Sourcing Tips", href: "/#insights" },
  { label: "About", href: "/about" },
] as const;

export const buyerServices = [
  { name: "Product Sourcing", description: "We search our network and the wider Iranian market for suitable options.", icon: "search-users" },
  { name: "Quote Comparison", description: "We help collect and compare commercial offers from relevant suppliers.", icon: "compare" },
  { name: "Commercial Negotiation", description: "We support communication on price, quantity, specifications and terms.", icon: "handshake" },
  { name: "Supplier Verification", description: "We help evaluate supplier information and coordinate verification steps.", icon: "badge-check" },
  { name: "Trade Coordination", description: "We coordinate documentation, logistics and shipment partners where required.", icon: "truck" },
] as const;

export const trustItems = [
  "Direct access to selected Iranian producers",
  "One local point of contact in Iran",
  "Alternative supplier search",
  "Multiple-option and quotation comparison",
  "Local-language communication and negotiation",
  "Support from inquiry to commercial coordination",
] as const;

export const credibilityItems = [
  { title: "Selected Producer Access", description: "Start with producers already known to our network.", icon: "factory" },
  { title: "Local Market Coordination", description: "Work through one Iran-based commercial contact.", icon: "map" },
  { title: "Multi-Supplier Comparison", description: "Review relevant options before selecting a supplier.", icon: "compare" },
  { title: "Buyer-Side Sourcing", description: "Keep your requirement and commercial priorities central.", icon: "shield-check" },
] as const;

export const focusIndustries = [
  { name: "Materials & Equipment", description: "Steel, minerals, ferroalloys and pump families listed in our product directory.", icon: "gem", cta: undefined },
  { name: "Agriculture & Produce", description: "Fruit and vegetables, with season, grade, packing and destination checked for each enquiry.", icon: "flask", cta: undefined },
  { name: "Custom Sourcing", description: "Need a different product? Start with a specification so we can assess suitable sourcing options.", icon: "search", cta: "Prepare a requirement" },
] as const;

export const processSteps = [
  { title: "Tell Us What You Need", description: "Share the product, specification, quantity and destination.", icon: "file" },
  { title: "We Research & Compare", description: "We check our network and relevant suppliers for suitable options.", icon: "compare" },
  { title: "Receive Options", description: "Review quotations, supplier options and commercial terms.", icon: "mail" },
  { title: "Negotiate & Coordinate", description: "We support agreement and coordinate shipment-related next steps.", icon: "handshake" },
] as const;

export const manufacturerServices = [
  "Buyer identification",
  "Market and import-activity research using legitimate data sources",
  "Personalized outbound outreach",
  "Lead qualification",
  "Introduction and early-stage commercial support",
] as const;
